// Shared Recharts styling in the admin-panel palette.
export const CHART_COLORS = ["#225881", "#F5A623", "#22B07D", "#0EA5E9", "#8B5CF6", "#F43F5E", "#94A3B8", "#14B8A6", "#D08C13"];

export const axisProps = { stroke: "#94a3b8", fontSize: 11, tickLine: false, axisLine: false };
export const gridProps = { strokeDasharray: "3 3", stroke: "rgba(166,180,200,0.45)", vertical: false };

export const tooltipProps = {
  contentStyle: {
    background: "#EEF2F8",
    border: "none",
    borderRadius: 12,
    fontSize: 12,
    color: "#225881",
    boxShadow: "8px 8px 18px rgba(166,180,200,0.50), -6px -6px 16px rgba(255,255,255,1)",
  },
  cursor: { fill: "rgba(166,180,200,0.20)" },
};
